import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, useAxiosClient, useMutation } from '@lumahealthhq/ui-model';
import { EModel } from '@lumahealthhq/ui-model-types';
import { getModelBasePath } from '@lumahealthhq/ui-utils';
var basePath = 'followupWorkflows';
var crud = createCrud(basePath);

/* Default queries */
export var useFollowupWorkflowCount = crud.makeCount();
export var useFollowupWorkflowById = crud.makeFindById();
export var useFollowupWorkflowByIds = crud.makeFindByIds();
export var useFollowupWorkflowMany = crud.makeFindMany();
export var useFollowupWorkflowOne = crud.makeFindOne();
export var useFollowupWorkflowPagination = crud.makePagination();

/* Default mutations */
export var useFollowupWorkflowCreateOne = crud.makeCreateOne();
export var useFollowupWorkflowUpdateOne = crud.makeUpdateOne();
export var useFollowupWorkflowRemoveById = crud.makeRemoveById();

/* Custom mutations */
export function useFollowupWorkflowPublishToGallery() {
  var axiosClient = useAxiosClient();
  function mutationFn(_x) {
    return _mutationFn.apply(this, arguments);
  }
  function _mutationFn() {
    _mutationFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var id, data, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            id = _ref.id, data = _ref.data;
            _context.next = 3;
            return axiosClient.post("v2/".concat(basePath, "/").concat(id, "/publish"), _extends({}, data, {
              artwork: []
            }));
          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _mutationFn.apply(this, arguments);
  }
  return useMutation([basePath, getModelBasePath(EModel.FollowupWorkflowGallery)], mutationFn);
}